import React, { FormEvent, useEffect, useState } from "react";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "@mui/material";
import SimpleInput from "../SimpleInput";
import PrimaryBtn from "../GlobalComponents/primaryBtn";
import httpRequest from "src/helpers/httpRequest";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CustomWebsiteDropdown from "../GlobalComponents/Widget/CustomWebsiteDropdown";

interface IObj {
  _id?: string;
  productId?: string;
  productName?: string;
  frequency?: string;
  dosage?: string;
  instruction?: string;
}

const initialState: IObj = { frequency: "", dosage: "", instruction: "" };
interface IProps {
  productId: string | null;
  productName: string;
  appointmentId: string | null;
  type: "pharmacy" | "diagnostic" | "homecare";
  show: boolean;
  onClose: () => void;
  isEdit?: boolean;
  isEditData?: IObj | null;
  onUpdate?: (data: IObj) => void;
}
const customeStyle: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 500,
};
// Style for the close button container
const backBtnMaain: React.CSSProperties = {
  position: "absolute",
  top: -10,
  right: -10,
  backgroundColor: "red",
  borderRadius: 100,
  width: 20,
  height: 20,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const AddProductPrescribeModal: React.FC<IProps> = ({
  productId = "",
  productName = "",
  appointmentId = "",
  type,
  show = false,
  onClose = () => {},
  isEdit = false,
  isEditData = null,
  onUpdate = () => {},
}) => {
  const navigate = useNavigate();

  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [errStates, setErrStates] = useState<IObj>(initialState);
  const [payload, setPayload] = useState<IObj>(initialState);

  const handleChange = (key: keyof IObj, val: string) => {
    setErrStates((prev) => ({ ...prev, [key]: "" }));
    setPayload((prev) => ({ ...prev, [key]: val }));
  };

  const handleClose = () => {
    onClose();
    setPayload(initialState);
    setErrStates(initialState);
  };

  const validateForm = (): boolean => {
    const errors: typeof errStates = {
      frequency:
        type === "pharmacy" && !payload.frequency
          ? "Frequency is required."
          : "",
      dosage:
        type === "pharmacy" && !payload.dosage ? "Dosage is required." : "",
      instruction: !payload.instruction ? "Instruction is required." : "",
    };
    setErrStates(errors);
    return !Object.values(errors).some((error) => error !== ""); // .some return boolean
  };
  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    if (validateForm()) {
      setIsLoader(true);
      const { res, err } = await httpRequest<{ message: string , data?: IObj}>({
        method: isEdit ? "put" : "post",
        path: isEdit ? `/appoiment/edit-prescribe/${isEditData?._id}?productType=${type}` : `/appoiment/add-prescribe?productType=${type}`,
        params: { ...payload, appointmentId, productId, productName },
      });
      if (res) {
        toast(res?.message || "Success!", { type: "success" });
        navigate(`/doctor/appointment/${appointmentId}/prescribe?type=${type}`);
        if (onUpdate) {
          onUpdate(res?.data || initialState);
        }
      } else {
        toast(err, { type: "error" });
      }
      setIsLoader(false);
    }
  };

  useEffect(() => {
      setPayload({
        frequency: isEditData?.frequency || "",
        dosage: isEditData?.dosage || "",
        instruction: isEditData?.instruction || "",
      });
      setErrStates({
        frequency: "",
        dosage: "",
        instruction: "",
      });
  }, [isEditData]);

  return (
    <Modal
      open={show}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div
        style={customeStyle}
        className="bg-[#ffffff] w-[600px] rounded-[8px]"
      >
        <div className="px-5 py-3 border-b">
          <button onClick={handleClose} style={backBtnMaain}>
            <FontAwesomeIcon
              className="font-size-16px text-white"
              icon={faXmark}
              size="2x"
            />
          </button>
          <h1 className="font-size-20px font-Poppins-SemiBold text-center leading-1 text-[#004540]">
            {type === "pharmacy"
              ? isEdit ? "Edit Medicine" : "Add Medicine"
              : type === "diagnostic"
              ? isEdit ? "Edit Test" : "Add Test"
              : type === "homecare"
              ? isEdit ? "Edit Homecare" : "Add Homecare"
              : ""}
          </h1>
        </div>
        <div className="px-5 py-3">
          <form onSubmit={handleSubmit}>
            <div className="grid">
              {type === "pharmacy" && (
                <>
                  <CustomWebsiteDropdown
                    options={["1+1+1", "1+0+0", "0+1+0", "0+0+1", "1+1+0"].map(
                      (v: string) => ({
                        value: v,
                        label: v,
                      })
                    )}
                    setData={(data) =>
                      handleChange("frequency", data?.[0]?.value || "")
                    }
                    data={
                      payload.frequency
                        ? [
                            {
                              value: payload.frequency,
                              label: payload.frequency,
                            },
                          ]
                        : []
                    }
                    mainDivClass="w-full"
                    dropdownMainClass="w-full"
                    dropdownInnerClass="w-full"
                    dropdownInnerStyle={{ width: "100%" }}
                    showRadioBtn
                    error={errStates.frequency}
                    labelText="Frequency"
                    placeholder="Select Frequency"
                  />
                  <CustomWebsiteDropdown
                    options={["1", "2", "3", "4"].map((v: string) => ({
                      value: v,
                      label: v,
                    }))}
                    setData={(data) =>
                      handleChange("dosage", data?.[0]?.value || "")
                    }
                    data={
                      payload.dosage
                        ? [{ value: payload.dosage, label: payload.dosage }]
                        : []
                    }
                    mainDivClass="w-full"
                    dropdownMainClass="w-full"
                    dropdownInnerClass="w-full"
                    dropdownInnerStyle={{ width: "100%" }}
                    showRadioBtn
                    error={errStates.dosage}
                    labelText="Dosage"
                    placeholder="Select Dosage"
                  />
                </>
              )}
              <SimpleInput
                type="textArea"
                value={payload.instruction || ""}
                onChange={(val: string) => handleChange("instruction", val)}
                isLabel={true}
                labelText="Instructions"
                rows={5}
                maxLength={300}
                isLimit={300}
                extraStyle={{
                  borderColor: "#00A297",
                  marginTop: "0.25rem",
                }}
                error={errStates.instruction}
              />
            </div>
            <div className="flex justify-end">
              <PrimaryBtn
                loader={isLoader}
                ButtonText={isEdit ? "Update" : "Add"}
                type="submit"
                btnExtraStyle={{
                  borderRadius: "1.5rem",
                  backgroundColor: "#004540",
                  padding: "5px 30px",
                  fontWeight: "500",
                }}
              />
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default AddProductPrescribeModal;
